import { render } from "./ReservationsList.vue?vue&type=template&id=21985792&scoped=true"
import script from "./ReservationsList.vue?vue&type=script&lang=js"
export * from "./ReservationsList.vue?vue&type=script&lang=js"

import "./ReservationsList.vue?vue&type=style&index=0&id=21985792&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21985792"]])

export default __exports__